import inputTypes from './operator-selector/supported-input-types';

export function getDefaultInputValue(operator) {

  if (operator.supportedInputType === inputTypes.TEXT) {
    return { key: '' };
  }

  if (operator.supportedInputType === inputTypes.NUMBER) {
    return { key: '' };
  }

  return [];

}